import { useTheme } from '@emotion/react';

import Svg from '../svg/Svg';

import { GraphicProps } from './type';

const GraphicGlasses = ({ isAct = false, ...rest }: GraphicProps) => {
  const theme = useTheme();

  return (
    <Svg {...rest}>
      <path
        d="M11.3516 13.498L14.3331 13.4507L14.3178 15.4807L11.3362 15.528L11.3516 13.498Z"
        fill={isAct ? theme.colors.secondary : theme.colors.gray2}
      />
      <path
        d="M2.65345 12.2051H7.83275L3.61742 13.2128L2.9247 17.6319L1.96155 16.1596C1.88512 16.0428 1.8447 15.9089 1.84466 15.7723L1.84375 12.954C1.84362 12.5404 2.20617 12.2051 2.65345 12.2051Z"
        fill={isAct ? theme.colors.primary : theme.colors.gray3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.94312 13.4373H5.82888C4.7232 13.4373 3.82686 14.2661 3.82686 15.2885L3.82686 16.1113C3.82686 17.1337 4.7232 17.9626 5.82888 17.9626H8.94312C10.0488 17.9626 10.9451 17.1337 10.9451 16.1113V15.2885C10.9451 14.2661 10.0488 13.4373 8.94312 13.4373ZM5.82888 12.2031C3.98607 12.2031 2.49219 13.5845 2.49219 15.2885V16.1113C2.49219 17.8153 3.98607 19.1967 5.82888 19.1967H8.94312C10.7859 19.1967 12.2798 17.8153 12.2798 16.1113V15.2885C12.2798 13.5845 10.7859 12.2031 8.94312 12.2031H5.82888Z"
        fill={isAct ? theme.colors.primary : theme.colors.gray3}
      />
      <path
        d="M23.0341 12.207H17.8548L22.0701 13.2148L22.7628 17.6339L23.7259 16.1616C23.8024 16.0448 23.8428 15.9108 23.8428 15.7743L23.8437 12.956C23.8439 12.5424 23.4813 12.207 23.0341 12.207Z"
        fill={isAct ? theme.colors.primary : theme.colors.gray3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7444 13.4432H19.8586C20.9643 13.4432 21.8606 14.272 21.8606 15.2944V16.1172C21.8606 17.1396 20.9643 17.9684 19.8586 17.9684H16.7444C15.6387 17.9684 14.7424 17.1396 14.7424 16.1172V15.2944C14.7424 14.272 15.6387 13.4432 16.7444 13.4432ZM19.8586 12.209C21.7014 12.209 23.1953 13.5904 23.1953 15.2944V16.1172C23.1953 17.8212 21.7014 19.2026 19.8586 19.2026H16.7444C14.9016 19.2026 13.4077 17.8212 13.4077 16.1172V15.2944C13.4077 13.5904 14.9016 12.209 16.7444 12.209H19.8586Z"
        fill={isAct ? theme.colors.primary : theme.colors.gray3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.3086 6.32769C7.11319 6.25653 6.90045 6.24807 6.7 6.30348L3.76408 7.11507C3.23176 7.26222 2.91952 7.81304 3.06667 8.34536C3.21383 8.87768 3.76465 9.18992 4.29696 9.04277L6.92472 8.31637L22.3845 13.9459C22.9035 14.1349 23.4773 13.8673 23.6663 13.3484C23.8553 12.8295 23.5878 12.2556 23.0688 12.0666L7.3086 6.32769Z"
        fill={isAct ? theme.colors.primary : theme.colors.gray3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3242 6.37651C18.5196 6.30536 18.7324 6.29689 18.9328 6.35231L21.8687 7.1639C22.4011 7.31105 22.7133 7.86187 22.5661 8.39419C22.419 8.92651 21.8682 9.23875 21.3358 9.0916L18.7081 8.3652L3.2483 13.9947C2.72935 14.1837 2.15547 13.9162 1.9665 13.3972C1.77753 12.8783 2.04503 12.3044 2.56398 12.1154L18.3242 6.37651Z"
        fill={isAct ? theme.colors.primary : theme.colors.gray3}
      />
      <rect
        x="4.04688"
        y="13.5312"
        width="6.71875"
        height="4.26562"
        rx="1.75"
        stroke={isAct ? theme.colors.primary : theme.colors.gray3}
        strokeWidth="0.5"
      />
      <rect
        x="14.9375"
        y="13.5312"
        width="6.71875"
        height="4.26562"
        rx="1.75"
        stroke={isAct ? theme.colors.primary : theme.colors.gray3}
        strokeWidth="0.5"
      />
    </Svg>
  );
};

export default GraphicGlasses;
